<section
  class="panel"
  [class.panel--warning]="vm?.variant === Variant.WARNING"
  [class.panel--empty]="vm?.variant === Variant.EMPTY"
>
  <div class="panel__row">
    <div class="panel__text">
      <ng-container *ngIf="vm?.variant === Variant.WARNING; else emptyCopy">
        <p class="panel__headline">No submissions in {{ vm.days }} days</p>
        <p class="panel__body">
          Your account is at risk for closing due to a lack of submissions. Accounts inactive for 90 days are
          deactivated.
        </p>
      </ng-container>
      <ng-template #emptyCopy>
        <p class="panel__headline">No submissions yet</p>
        <p class="panel__body">Accounts inactive for 90 days are deactivated.</p>
      </ng-template>
    </div>
    <a mat-button class="panel__cta" [routerLink]="WebPaths.NewSubmission">+ NEW SUBMISSION</a>
  </div>
  <mat-progress-bar
    class="panel__progress"
    mode="determinate"
    color="accent"
    aria-label="Days since last submission"
    [value]="vm?.progressPercent ?? 0"
  ></mat-progress-bar>
</section>
